module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('main', [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [(this.listData != '' && this.videotype != '3') ? _c('div', {
    staticClass: "video"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isBanner),
      expression: "isBanner"
    }],
    attrs: {
      "src": this.poster,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.listData != '' && this.videotype != '3' && !_vm.isBanner),
      expression: "this.listData != '' && this.videotype != '3' && !isBanner"
    }]
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.togglefull()
      }
    }
  }, [_c('JSDecoderPlayer', {
    ref: "JSDecoderPlayer",
    class: {
      vidplayer: true, fullscreen: _vm.isfull
    }
  })], 1)]), _vm._v(" "), _c('el-collapse', {
    staticClass: "mubottom"
  }, [_c('el-collapse-item', {
    attrs: {
      "name": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('img', {
    attrs: {
      "src": require("../img/sp1.png")
    }
  }), _vm._v("明厨亮灶信号源:\n            ")]), _vm._v(" "), _c('nav', {
    staticClass: "info"
  }, [_c('label', [_c('i', {
    staticClass: "el-icon-menu"
  }), _vm._v("信号源:")]), _vm._v(" "), _c('div', {
    staticClass: "info-right"
  }, [_c('ul', {
    staticClass: "info-list"
  }, _vm._l((_vm.listData), function(item) {
    return _c('li', {
      key: item.unid,
      class: {
        videonameactive: item.name == _vm.showactive
      },
      on: {
        "click": function($event) {
          _vm.videoitem(item)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(item.name) + "\n                  ")])
  }))])])], 2)], 1)], 1) : _c('div', {
    staticClass: "none_video"
  }, [(this.videotype == '0') ? _c('img', {
    attrs: {
      "src": require("../img/bg1.png")
    }
  }) : _vm._e(), _vm._v(" "), (this.videotype == '1') ? _c('img', {
    attrs: {
      "src": require("../img/bg2.png")
    }
  }) : _vm._e(), _vm._v(" "), (this.videotype == '2') ? _c('img', {
    attrs: {
      "src": require("../img/bg3.png")
    }
  }) : _vm._e(), _vm._v(" "), (this.videotype == '3') ? _c('img', {
    attrs: {
      "src": require("../img/bg4.png")
    }
  }) : _vm._e(), _vm._v(" "), (this.videotype == null) ? _c('img', {
    attrs: {
      "src": require("../img/bg4.png")
    }
  }) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0347ea28","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/videolist.vue
// module id = 472
// module chunks = 1